import run from './run';
import BridgeFormUtilConfig from './BridgeFormUtilConfig';


export default {
  run,
  settings: BridgeFormUtilConfig,
};
